import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataPaymentTermsActions } from "./payment-terms.actions";

// **************************************************************************
// PAYMENT TERMS REDUCER
// **************************************************************************

const load = on(DataPaymentTermsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        paymentTerm: {
            ...state.data.paymentTerm,
            paymentTermsLoading: true,
        },
    },
}));

const loadSuccess = on(DataPaymentTermsActions.loadSuccess, (state: ApplicationStore, { paymentTerms }) => ({
    ...state,
    data: {
        ...state.data,
        paymentTerm: {
            ...state.data.paymentTerm,
            paymentTerms,
            paymentTermsLoading: false,
        },
    },
}));

const loadFailure = on(DataPaymentTermsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        paymentTerm: {
            ...state.data.paymentTerm,
            paymentTermsLoading: false,
        },
    },
}));

export const paymentTermsReducer = [load, loadSuccess, loadFailure];
